import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PopoutTheme } from 'modules/ui/popout/PopoutTheme';
import React from 'react';

export interface SidePopoutState {
  container?: React.ReactNode;
  popoutVisible: boolean;
  theme?: PopoutTheme;
  transitioning?: boolean;
}

const initialState: SidePopoutState = {
  popoutVisible: false,
  theme: PopoutTheme.Light,
  transitioning: false,
};

export const popoutSlice = createSlice({
  name: 'popout',
  initialState,
  reducers: {
    setPopoutContainer: (
      state,
      action: PayloadAction<{
        newContainer?: React.ReactNode;
        theme?: PopoutTheme;
      }>,
    ) => {
      state.container = action.payload.newContainer;
      state.theme = action.payload.theme || PopoutTheme.Light;
    },
    setPopoutVisible: (state, action: PayloadAction<boolean>) => {
      state.popoutVisible = action.payload;
    },
    setTransitioningState: (state, action: PayloadAction<boolean>) => {
      state.transitioning = action.payload;
    },
  },
});

export const { setPopoutContainer, setPopoutVisible, setTransitioningState } =
  popoutSlice.actions;

export default popoutSlice.reducer;
